import { styled, Box } from '@mui/material';

export const BodyContainer = styled(Box)(({ theme }) => ({
  margin: `${theme.spacing(1)} 0px`,
}));
